import { Loader } from 'google-maps'

export default {
    init() {},
    finalize() {
        // π ----
        // :: MAP SEARCH ---------------------------::
        // ____
        let geocoder
        let map
        const campLocations = []

        const loader = new Loader(winshape.maps_api, '')

        loader.load().then(google => {
            console.log(`it's been initialized!!`)

            geocoder = new google.maps.Geocoder()
            const myLatlng = new google.maps.LatLng(33.5248, -86.8127)
            const mapOptions = {
                zoom: 5,
                center: myLatlng,
                scrollwheel: false,
            }

            const iconImage = {
                url: `${winshape.theme_directory}/dist/images/icons/map-marker.svg`,
                size: new google.maps.Size(20, 29),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(10, 29),
            }

            const specialIcon = {
                url: `${winshape.theme_directory}/dist/images/icons/map-marker-blue.svg`,
                size: new google.maps.Size(20, 29),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(10, 29),
            }

            map = new google.maps.Map(document.getElementById('map-container'), mapOptions)

            function addMarker(latlng, address, city, state, date, title, permalink, isSpecial) {
                const marker = new google.maps.Marker({
                    position: latlng,
                    map,
                    title,
                    icon: !isSpecial ? iconImage : specialIcon,
                })

                const dateString = !isSpecial ? date : 'Multiple dates available'

                /* :: Info Window
                {+} ---------------------------------- */
                const contentString = `
                <div class="p-2 md:p-4">
                    <div id="siteNotice"></div>
                    <h3 class="font-bold text-xl mb-2">
                        ${title}
                    </h3>
                    <div class="">
                        <p class="text-sm">${address}<br>${city}, ${state}</p>
                        <p class="font-bold text-base text-grey mt-2">
                            ${dateString}
                        </p>
                        <a href="${permalink}" class="relative inline-flex flex-col font-bold text-xs leading-none tracking-wider uppercase mt-6 overflow-hidden transition-quad">
                            <div class="relative">
                                <div class="transition-circ btn__text01">Explore Camp</div>
                                <div class="absolute top-0 left-0 transition-circ btn__text02">Explore Camp</div>
                            </div>
                            <div class="relative w-full h-1 bg-black mt-2"></div>
                        </a>
                    </div>
                </div>`

                const infowindow = new google.maps.InfoWindow({
                    content: contentString,
                    maxWidth: 300,
                })

                google.maps.event.addListener(marker, 'click', () => {
                    infowindow.open(map, marker)
                })
            }

            /* :: Generate the Map Markers
            {+} ---------------------------------- */
            $.ajax({
                url: winshape.ajaxurl,
                dataType: 'json',
                data: { action: 'fetchDayCamps' },
                success(posts) {
                    // :: Returned Result ------------ //
                    $.each(posts, function () {
                        // :: Each Camp ------------ //
                        $.each(this, function () {
                            const camp = this

                            if (camp.coordinates) {
                                const thisLatlng = camp.coordinates.split(',')
                                const rawLat = thisLatlng[0]
                                const rawLng = thisLatlng[1]
                                const thisLat = parseFloat(rawLat.replace('(', ''))
                                const thisLng = parseFloat(rawLng)

                                const campMarker = {
                                    lat: thisLat,
                                    lng: thisLng,
                                    dates: camp.dates,
                                    address: camp.address,
                                    city: camp.city,
                                    state: camp.state,
                                    zip: camp.zip,
                                    title: camp.title,
                                    permalink: camp.permalink,
                                    isSpecial: camp.special,
                                }

                                addMarker(
                                    new google.maps.LatLng(thisLat, thisLng),
                                    camp.address,
                                    camp.city,
                                    camp.state,
                                    camp.dates,
                                    camp.title,
                                    camp.permalink,
                                    camp.isSpecial,
                                )

                                campLocations.push([thisLat, thisLng, campMarker])
                            } else {
                                console.log(`${camp.title} doesn't have any map coordinates setup.`)
                            }
                        })
                    })
                },
                error() {
                    console.log('Could not fetch any camps!')
                },
            })
        })

        function find_closest(userLocation) {
            const userLat = userLocation.lat()
            const userLon = userLocation.lng()
            const userLatLon = [userLat, userLon]

            // helper functions to find distance from two points
            function toRad(x) {
                return (x * Math.PI) / 180
            }

            function distanceFromTo(user, location) {
                const locLat = location[0]
                const locLon = location[1]
                const usrLat = user[0]
                const usrLon = user[1]
                const R = 3961
                const x1 = usrLat - locLat
                const dLat = toRad(x1)
                const x2 = usrLon - locLon
                const dLon = toRad(x2)

                const a =
                    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                    Math.cos(toRad(locLat)) * Math.cos(toRad(usrLat)) * Math.sin(dLon / 2) * Math.sin(dLon / 2)

                const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
                const d = R * c

                return d
            }

            // compare current opportunity locations to user's location
            // var closestLocation = locations[0];
            const distances = []

            campLocations.forEach((item, index) => {
                const thisLocation = [item[0], item[1]]

                const thisDistance = distanceFromTo(userLatLon, item)
                distances.push([thisDistance, item[2]])
            })

            const sortedDistances = distances.sort((a, b) => a[0] - b[0])

            const nearestLocations = document.getElementsByClassName('location-strip')[0]
            // remove all children first
            while (nearestLocations.firstChild) {
                nearestLocations.removeChild(nearestLocations.firstChild)
            }

            sortedDistances.every((item, index) => {
                const distance = item[0]
                const thisPlace = item[1]
                const theseDates = !thisPlace.isSpecial ? thisPlace.dates : 'Multiple dates available'

                /* :: Location Card
                {+} ---------------------------------- */
                const newLocationCard = `
                <a
                    href="${thisPlace.permalink}"
                    class="relative flex flex-col flex-shrink-0 w-64 sm:w-80 bg-grey-darker hover:bg-grey-dark text-white rounded-sm mx-4 p-8 transition-quad hover:-translate-y-4 group"
                >
                    <div>
                        <div id="siteNotice"></div>
                        <h3 class="font-bold text-2xl text-red-lighter group-hover:text-red-light mb-4 transition">
                            ${thisPlace.title}
                        </h3>
                        <p>
                            ${thisPlace.address}<br>
                            ${thisPlace.city}, ${thisPlace.state}
                        </p>
                        <p class="font-bold text-lg mt-4">
                            ${theseDates}
                        </p>
                        <p class="italic mt-4">
                            ${parseInt(distance)} miles away
                        </p>
                    </div>
                    <div class="flex-1 flex items-end">
                        <button
                            class="relative inline-flex flex-col font-bold text-xs text-green-light leading-none tracking-wider uppercase mt-6 overflow-hidden transition-quad"
                        >
                            <div class="relative">
                                <div class="transition-circ btn__text01">Explore Camp</div>
                                <div class="absolute top-0 left-0 transition-circ btn__text02">Explore Camp</div>
                            </div>
                            <div class="relative w-full h-1 bg-green-light mt-2"></div>
                        </button>
                    </div>
                </a>`

                nearestLocations.insertAdjacentHTML('beforeend', newLocationCard)
                nearestLocations.parentNode.parentNode.style.marginTop = 0
                nearestLocations.parentNode.parentNode.style.zIndex = 0

                $('[data-camp-results]').removeClass('hidden')

                return index >= 9 ? false : true
            })
        }

        function codeAddress(addy) {
            const address = addy
            geocoder.geocode(
                {
                    address,
                },
                (results, status) => {
                    if (status == google.maps.GeocoderStatus.OK) {
                        map.setZoom(9)
                        map.panTo(results[0].geometry.location)
                        const marker = new google.maps.Marker({
                            map,
                            position: results[0].geometry.location,
                            icon: {
                                path: google.maps.SymbolPath.CIRCLE,
                                scale: 10,
                            },
                        })

                        find_closest(results[0].geometry.location)
                    } else {
                        alert('The address you entered could not be verified. Please try again.')
                    }
                },
            )
        }

        document.getElementById('plot-button').onclick = event => {
            const addy = document.getElementById('address-field').value
            codeAddress(addy)
        }

        document.getElementsByClassName('map-search')[0].onsubmit = event => {
            event.preventDefault()
            const addy = document.getElementById('address-field').value
            codeAddress(addy)
        }
    },
}
